import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Box } from 'pcln-design-system';
import { Carousel } from 'pcln-carousel';
import { HotelFilterComponent } from './HotelFilterComponent';
import analytics from '../analytics/analytics';
import HotelListingCard from './HotelListingCard/HotelListingCard';
import LoadMore from './HotelListingCard/components/LoadMore/LoadMore';
import { useSetHotelPinOnMapHook } from './useSetHotelPinOnMapHook';
import { useRealTimeContext } from '../hooks/useRealTimeContext';
import { ChatbotDataContext } from '../context/ChatbotDataContext';
export const sopqImages = ['https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-3-2.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp', 'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-3-3.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp', 'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-4-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp', 'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-3-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp', 'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-2-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp', 'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-4-3.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp', 'https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-2-3.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp'];
export const getDefaultSopqRoomImage = starRating => {
  // If star Rating is not a number
  // Use default sopqImages
  const imageRating = Number.isNaN(Number(starRating)) ? 0 : Math.floor(Number(starRating));
  return imageRating ? `https://s1.pclncdn.com/design-assets/sopq/img-sopq-room-${imageRating}-1.jpg?width=250&crop=1:1&dpr=2&format=jpg&opto&auto=avif,webp` : sopqImages[0];
};
const transformAmenitiesText = amenities => {
  if (amenities) {
    const amenityMap = {
      FINTRNT: 'Free Internet Access',
      FINTRAVL: 'Free Internet Available',
      FINTRPUB: 'Free Internet In Public Areas',
      FINTRRM: 'Free Internet In Room',
      'FREE WIFI': 'Free Internet In Room',
      PETALLOW: 'Pets Allowed',
      NSMKFAC: 'No Smoking Rooms/Facilities',
      BUSCNTR: 'Business Center',
      CASINO: 'Casino',
      FPRKING: 'Free Parking',
      BEDDING: 'Bedding',
      SPOOL: 'Swimming Pool',
      SPOOLIN: 'Indoor Swimming Pool',
      SPOOLOUT: 'Outdoor Swimming Pool',
      FITSPA: 'Fitness Center',
      SPA: 'Spa',
      FBRKFST: 'Free Breakfast',
      FBRKST: 'Free Breakfast',
      AIRSHUTTL: 'Airport Shuttle',
      FAIRSHUTTL: 'Free Airport Shuttle',
      HANDFAC: 'Accessible Rooms/Facilities',
      RESTRNT: 'Restaurant',
      BCHFRNT: 'Beachfront',
      FRIDGE: 'Fridge',
      MW: 'Microwave',
      TUB: 'Whirlpool',
      INCLUSIVE: 'All Inclusive',
      ADULTONLY: 'Adults Only',
      KITCHEN: 'Kitchen',
      KITCHENETTE: 'Kitchenette'
    };
    const firstTextMember = amenities.map(item => amenityMap[item]).join(', ');
    const secondTextMember = 'Fully Refundable Rates, Pay Later  Available';
    return [firstTextMember, secondTextMember];
  }
  return '';
};
export const transformListingProps = hotel => {
  var _a, _b, _c;
  const {
    ratesSummary,
    totalReviewCount,
    starRating,
    images,
    hotelFeatures,
    overallGuestRating,
    location,
    name,
    displayStrikePrice,
    hotelType
  } = hotel !== null && hotel !== void 0 ? hotel : {};
  const imageSrc = hotelType === 'SOPQ' ? ((_a = images === null || images === void 0 ? void 0 : images[0]) === null || _a === void 0 ? void 0 : _a.fastlyUrl) || getDefaultSopqRoomImage(starRating) : (_c = (_b = images === null || images === void 0 ? void 0 : images[0]) === null || _b === void 0 ? void 0 : _b.fastlyUrl) !== null && _c !== void 0 ? _c : '';
  return {
    imageSrc,
    amenitiesList: transformAmenitiesText(hotelFeatures === null || hotelFeatures === void 0 ? void 0 : hotelFeatures.highlightedAmenities),
    ratingsProps: {
      guestRating: totalReviewCount,
      hotelRating: starRating,
      overallRating: overallGuestRating
    },
    priceProps: {
      price: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.minPrice,
      totalPrice: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.grandTotal,
      currency: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.minCurrencyCodeSymbol,
      strikeThroughPrice: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.minStrikePrice,
      savingsPct: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.savingsPct,
      nightlyRateIncludingTaxesAndFees: ratesSummary.nightlyRateIncludingTaxesAndFees,
      nightlyRateExcludingTaxesAndFees: ratesSummary.nightlyRateExcludingTaxesAndFees,
      priceDisplayRegulation: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.priceDisplayRegulation,
      strikePriceExcludingTaxesAndFees: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.strikePriceExcludingTaxesAndFees,
      strikePriceIncludingTaxesAndFees: ratesSummary === null || ratesSummary === void 0 ? void 0 : ratesSummary.strikePriceIncludingTaxesAndFees,
      displayStrikePrice
    },
    headerText: {
      hotelName: name,
      neighborhoodName: location.neighborhoodName
    }
  };
};
export const HotelDetailCardsMessage = props => {
  var _a, _b, _c, _d, _e, _f;
  useEffect(() => {
    analytics.log(Object.assign({
      label: 'HotelSearchResult',
      message: 'HOTEL_CARDS_DISPLAY'
    }, props === null || props === void 0 ? void 0 : props.args));
  }, []);
  const {
    isShowMoreListingCards
  } = props;
  const {
    isMobile
  } = useContext(ChatbotDataContext);
  const highRatedHotels = (_b = (_a = props.searchResult) === null || _a === void 0 ? void 0 : _a.hotels) === null || _b === void 0 ? void 0 : _b.filter(hotel => hotel.overallGuestRating > 7.5);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [offset, setOffset] = useState(3);
  const [currentSlideOffset, setCurrentSlideOffset] = useState(0);
  const [displaySopqOnly, setDisplaySopqOnly] = useState(false);
  const {
    startRealTime
  } = useRealTimeContext();
  const hotelsLen = (_d = (_c = props.searchResult) === null || _c === void 0 ? void 0 : _c.hotels) === null || _d === void 0 ? void 0 : _d.length;
  const sortedHotels = (_e = props.searchResult) === null || _e === void 0 ? void 0 : _e.hotels;
  const hasMoreHotels = offset < hotelsLen;
  const {
    hasSopqHotel,
    hasRtlHotel
  } = (((_f = props.searchResult) === null || _f === void 0 ? void 0 : _f.hotels) || []).reduce((flags, hotel) => {
    if (hotel.hotelType === 'SOPQ') {
      flags.hasSopqHotel = true;
    }
    if (hotel.hotelType !== 'SOPQ') {
      flags.hasRtlHotel = true;
    }
    return flags;
  }, {
    hasSopqHotel: false,
    hasRtlHotel: false
  });
  const displayResult = useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (isShowMoreListingCards) {
      const result = [...(sortedHotels === null || sortedHotels === void 0 ? void 0 : sortedHotels.slice(0, offset))];
      result.push({
        type: hasMoreHotels ? 'loadMore' : 'endOfList'
      });
      return result;
    } else {
      if (displaySopqOnly) {
        return (_b = (_a = props.searchResult) === null || _a === void 0 ? void 0 : _a.hotels) === null || _b === void 0 ? void 0 : _b.filter(hotel => hotel.hotelType === 'SOPQ');
      }
      return props.displayVectorSearchResult ? (_c = props.searchResult) === null || _c === void 0 ? void 0 : _c.hotels : (highRatedHotels === null || highRatedHotels === void 0 ? void 0 : highRatedHotels.length) ? (_f = (_e = (_d = props.searchResult) === null || _d === void 0 ? void 0 : _d.hotels) === null || _e === void 0 ? void 0 : _e.filter(hotel => hotel.overallGuestRating > 7.5)) === null || _f === void 0 ? void 0 : _f.slice(0, 3) : (_h = (_g = props.searchResult) === null || _g === void 0 ? void 0 : _g.hotels) === null || _h === void 0 ? void 0 : _h.slice(0, 3);
    }
  }, [props, offset, hasMoreHotels, displaySopqOnly]);
  function onLoadMore() {
    var _a, _b;
    analytics.log({
      label: 'LoadMoreListingHotels',
      message: 'LOAD_MORE_HOTELS_CLICKED'
    });
    if (offset < ((_b = (_a = props.searchResult) === null || _a === void 0 ? void 0 : _a.hotels) === null || _b === void 0 ? void 0 : _b.length)) {
      setCurrentSlide(currentSlide + 3);
      setOffset(offset + 3);
      setCurrentSlideOffset(currentSlideOffset + 1);
    }
  }
  useSetHotelPinOnMapHook({
    displaySopqOnly,
    displayResult,
    args: props === null || props === void 0 ? void 0 : props.args
  });
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    maxWidth: startRealTime && isMobile ? '370px' : null
  }, React.createElement(Carousel, {
    arrowPositions: 'side',
    showForwardBackBtns: true,
    visibleSlides: 2,
    onSlideChange: function () {},
    overflowAllowancePxX: isMobile ? 16 : 32,
    currentSlide: currentSlide,
    displayArrowsMobile: isMobile
  }, displayResult === null || displayResult === void 0 ? void 0 : displayResult.map(function (hotel, index) {
    if (hotel.type === 'loadMore' && isShowMoreListingCards) {
      return React.createElement(Box, {
        key: 'load_more_listing_card'
      }, React.createElement(LoadMore, {
        onLoadMore: onLoadMore
      }));
    }
    if (hotel.type === 'endOfList') {
      return React.createElement(Box, {
        key: 'end_of_list_listing_card'
      });
    }
    return React.createElement(Box, {
      key: String(hotel.hotelId)
    }, React.createElement(HotelListingCard, {
      listingProps: transformListingProps(hotel),
      hotel: hotel,
      args: props === null || props === void 0 ? void 0 : props.args
    }));
  }))), startRealTime ? null : React.createElement(HotelFilterComponent, Object.assign({}, props, {
    hasSopqHotel: hasSopqHotel,
    hasRtlHotel: hasRtlHotel,
    displaySopqOnly: displaySopqOnly,
    toggleOnlyExpressDealClick: function () {
      analytics.log(Object.assign({
        label: 'HotelSearchResult',
        message: 'TOGGLE_EXPRESS_DEAL_RESULTS_BUTTON_CLICKED'
      }, props === null || props === void 0 ? void 0 : props.args));
      setDisplaySopqOnly(!displaySopqOnly);
    }
  })));
};